<template>
  <v-app>
    <nav-drawer v-if="Auth.isLoggedIn()" ref="refDrawer" />
    <app-bar
      v-if="!isExamMode()"
      @toggle-drawer="$refs.refDrawer.drawer = !$refs.refDrawer.drawer"/>

    <app-bar-exam v-if="isExamMode()"/>
  
    <v-content>
      <halter/>
      <snackbar/>
      <dialog-comp/>
      <router-view></router-view>
    </v-content>

    <app-footer/>

  </v-app>
</template>

<script>
import Auth from './services/auth'
import State from './services/state'

import AppBar from './components/layout/AppBar'
import AppBarExam from './components/layout/AppBarExam'
import NavDrawer from './components/layout/NavDrawer'
import AppFooter from './components/layout/AppFooter'
import Halter from './components/main/Halter'
import Snackbar from './components/main/Snackbar'
import DialogComp from './components/main/DialogComp'

export default {
  name: 'App',
  components: {
    AppBar,
    AppBarExam,
    NavDrawer,
    AppFooter,
    Halter,
    Snackbar,
    DialogComp,
  },
  created() {
    document.title = 'KorPhil Online Enrollment';
  },
  data() {
    return {
      Auth,
      State,
      drawer: null,
      route: this.$route
    }
  },
  methods: {
    isExamMode() {
      return this.$route.name == 'exam';
    }
  }
};
</script>

